import { DataModel } from 'common/models/utility-models/base-model';
import { BaseWidgetService } from './base-widget.service';
import { FormDataService } from 'common/services/data-services/base-data-services/form-data.service';

export abstract class FormWidgetService<T extends DataModel> extends BaseWidgetService<T> {
    constructor(public formDataService: FormDataService<T>) {
        super(formDataService);
    }

    processFormModel(model: any, meta: any, data: any): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            this.formDataService
                .submitModel(model, meta, data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    processFormModelGETAPI(params: string[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.formDataService
                .getDataByParams(params)
                .then((data: any) => {
                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    validationBeforeSubmit(model: any) {
        return true;
    }







}
